import React from 'react';

import {
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormHelperText,
  FormLabel,
  VStack,
} from '@chakra-ui/react';

import {Controller, useFormContext} from 'react-hook-form';

import {QuestionProps} from './question';

export function CheckboxQuestion(props: Readonly<QuestionProps>) {
  const {question} = props;
  const {control} = useFormContext();

  const options = question.options.map(it => (
    <Checkbox key={it.id} value={it.id} w='100%'>
      {it.value}
    </Checkbox>
  ));

  return (
    <FormControl>
      <FormLabel>{question.title}</FormLabel>
      <Controller
        control={control}
        name={question.id}
        render={({field: {onChange, value}}) => (
          <CheckboxGroup value={value} onChange={onChange}>
            <VStack justifyContent='flex-start'>{options}</VStack>
          </CheckboxGroup>
        )}
      />
      <FormHelperText>{question.description}</FormHelperText>
    </FormControl>
  );
}
